import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { Formik } from "formik";

const Question13 = ({ name, lang }) => {
  const [question13, setQuestion13] = useState(null);

  const handleQuestionChange = (e, setFieldValue) => {
    setFieldValue("question13", e.target.dataset.name);
    if (JSON.parse(localStorage.getItem("rateMyBossDetails"))) {
      let existingDetails = JSON.parse(
        localStorage.getItem("rateMyBossDetails")
      );

      Object.assign(existingDetails, {
        question13: e.target.dataset.name,
      });

      localStorage.setItem(
        "rateMyBossDetails",
        JSON.stringify(existingDetails)
      );
    }
  };

  useEffect(() => {
    if (JSON.parse(localStorage.getItem("rateMyBossDetails"))) {
      setQuestion13(
        JSON.parse(localStorage.getItem("rateMyBossDetails")).question13
      );
    }
  }, []);

  return (
    <div className="container">
      <div className="row">
        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <Formik
            initialValues={{
              question13: question13 ? question13 : "",
            }}
            enableReinitialize={true}
            onSubmit={(values, { setSubmitting }) => {
              setSubmitting(true);
            }}
          >
            {({
              values,
              errors,
              handleChange,
              handleSubmit,
              isSubmitting,
              setFieldValue,
            }) => (
              <div>
                {lang && lang === "spanish" ? (
                  <form className="rate_my_boss_form" onSubmit={handleSubmit}>
                    <div>
                      <p>
                        {" "}
                        <b>Q13</b>&nbsp;&nbsp;&nbsp;{" "}
                        <b>
                          <i>{name}</i>
                        </b>{" "}
                        &nbsp; gestiona adecuadamente los conflictos
                        interpersonales dentro de nuestro equipo.
                      </p>
                    </div>

                    <div
                      className="row"
                      style={{
                        marginTop: "70px",
                      }}
                    >
                      <div className="col-md-10">
                        <Form.Group className="row">
                          <div className="col-sm-3">
                            <div className="form-check">
                              <label className="form-check-label">
                                <input
                                  type="radio"
                                  className="form-check-input"
                                  name="question13"
                                  id="never"
                                  onChange={(e) =>
                                    handleQuestionChange(e, setFieldValue)
                                  }
                                  data-name={"never"}
                                  value={"never"}
                                  checked={values.question13 === "never"}
                                />{" "}
                                Nunca
                                <i className="input-helper"></i>
                              </label>
                            </div>
                          </div>
                          <div className="col-sm-3">
                            <div className="form-check">
                              <label className="form-check-label">
                                <input
                                  type="radio"
                                  className="form-check-input"
                                  name="question13"
                                  id="sometimes"
                                  onChange={(e) =>
                                    handleQuestionChange(e, setFieldValue)
                                  }
                                  data-name={"sometimes"}
                                  value={"sometimes"}
                                  checked={values.question13 === "sometimes"}
                                />{" "}
                                A veces
                                <i className="input-helper"></i>
                              </label>
                            </div>
                          </div>
                          <div className="col-sm-3">
                            <div className="form-check">
                              <label className="form-check-label">
                                <input
                                  type="radio"
                                  className="form-check-input"
                                  name="question13"
                                  id="often"
                                  onChange={(e) =>
                                    handleQuestionChange(e, setFieldValue)
                                  }
                                  data-name={"often"}
                                  value={"often"}
                                  checked={values.question13 === "often"}
                                />{" "}
                                A menudo
                                <i className="input-helper"></i>
                              </label>
                            </div>
                          </div>
                          <div className="col-sm-3">
                            <div className="form-check">
                              <label className="form-check-label">
                                <input
                                  type="radio"
                                  className="form-check-input"
                                  name="question13"
                                  id="always"
                                  onChange={(e) =>
                                    handleQuestionChange(e, setFieldValue)
                                  }
                                  data-name={"always"}
                                  value={"always"}
                                  checked={values.question13 === "always"}
                                />{" "}
                                Siempre
                                <i className="input-helper"></i>
                              </label>
                            </div>
                          </div>
                        </Form.Group>
                      </div>
                    </div>
                  </form>
                ) : (
                  <form className="rate_my_boss_form" onSubmit={handleSubmit}>
                    <div>
                      <p>
                        {" "}
                        <b>Q13</b>&nbsp;&nbsp;&nbsp;{" "}
                        <b>
                          <i>{name}</i>
                        </b>{" "}
                        &nbsp; appropriately manages interpersonal conflict
                        within our team.
                      </p>
                    </div>

                    <div
                      className="row"
                      style={{
                        marginTop: "70px",
                      }}
                    >
                      <div className="col-md-10">
                        <Form.Group className="row">
                          <div className="col-sm-3">
                            <div className="form-check">
                              <label className="form-check-label">
                                <input
                                  type="radio"
                                  className="form-check-input"
                                  name="question13"
                                  id="never"
                                  onChange={(e) =>
                                    handleQuestionChange(e, setFieldValue)
                                  }
                                  data-name={"never"}
                                  value={"never"}
                                  checked={values.question13 === "never"}
                                />{" "}
                                Never
                                <i className="input-helper"></i>
                              </label>
                            </div>
                          </div>
                          <div className="col-sm-3">
                            <div className="form-check">
                              <label className="form-check-label">
                                <input
                                  type="radio"
                                  className="form-check-input"
                                  name="question13"
                                  id="sometimes"
                                  onChange={(e) =>
                                    handleQuestionChange(e, setFieldValue)
                                  }
                                  data-name={"sometimes"}
                                  value={"sometimes"}
                                  checked={values.question13 === "sometimes"}
                                />{" "}
                                Sometimes
                                <i className="input-helper"></i>
                              </label>
                            </div>
                          </div>
                          <div className="col-sm-3">
                            <div className="form-check">
                              <label className="form-check-label">
                                <input
                                  type="radio"
                                  className="form-check-input"
                                  name="question13"
                                  id="often"
                                  onChange={(e) =>
                                    handleQuestionChange(e, setFieldValue)
                                  }
                                  data-name={"often"}
                                  value={"often"}
                                  checked={values.question13 === "often"}
                                />{" "}
                                Often
                                <i className="input-helper"></i>
                              </label>
                            </div>
                          </div>
                          <div className="col-sm-3">
                            <div className="form-check">
                              <label className="form-check-label">
                                <input
                                  type="radio"
                                  className="form-check-input"
                                  name="question13"
                                  id="always"
                                  onChange={(e) =>
                                    handleQuestionChange(e, setFieldValue)
                                  }
                                  data-name={"always"}
                                  value={"always"}
                                  checked={values.question13 === "always"}
                                />{" "}
                                Always
                                <i className="input-helper"></i>
                              </label>
                            </div>
                          </div>
                        </Form.Group>
                      </div>
                    </div>
                  </form>
                )}
              </div>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
};

export default Question13;
